import TYPES from '../../types';

// Domain
import {
  CustomerContractedInvestmentProductsRepository,
} from '@/modules/flagship/customer-contracted-investment-products/domain/repositories/customer-contracted-investment-products-repository';
import {
  CustomerContractedInvestmentProductsStateManager,
} from '@/modules/flagship/customer-contracted-investment-products/domain/state/customer-contracted-investment-products-state-manager';
import {
  CustomerContractedInvestmentProductsEntity,
} from '@/modules/flagship/customer-contracted-investment-products/domain/entities/customer-contracted-investment-products-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Query from '@/modules/shared/domain/use-cases/query';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class GetCustomerContractedInvestmentProductsQuery
  extends Query<Promise<CustomerContractedInvestmentProductsEntity>> {
  @Inject(TYPES.CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_REPOSITORY)
  private readonly repository!: CustomerContractedInvestmentProductsRepository;

  @Inject(TYPES.CUSTOMER_CONTRACTED_INVESTMENT_PRODUCTS_STATE_MANAGER)
  private readonly state_manager!: CustomerContractedInvestmentProductsStateManager;

  internalExecute(): Promise<CustomerContractedInvestmentProductsEntity> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.item);
      } else {
        this.repository.get()
          .then((item) => {
            this.state_manager.patch({ item, loaded: true });
            resolve(this.state_manager.state.item);
          })
          .catch(reject);
      }
    });
  }
}
